import { axios } from '@pukka/auth';
import { MOKA_GOAUTH_SERVICE } from '@pukka/common/constants';

import { BankAccountsModel } from '../models';

const BANK_LIST_URL = `${MOKA_GOAUTH_SERVICE}/business-service/v1/business/banks`;

async function getBankList(): Promise<BankAccountsModel.BankList> {
  const { data } = await axios.get(BANK_LIST_URL);

  return data;
}

export { BANK_LIST_URL, getBankList };
